<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>Select Event</glxy-page-title>
    <glxy-page-actions>
      <a [routerLink]="'/loop'">
        <button mat-stroked-button color="primary">Cancel</button>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper maxWidth="100%">
    @if (events$ | async; as events) {
      <div class="list mat-elevation-z1">
        @if ((loading$ | async) === false && events.length === 0) {
          <div class="message">Error loading events</div>
        }
        @if (events.length > 0) {
          <mat-nav-list>
            @for (event of events; track event) {
              <a [routerLink]="'../create'" [queryParams]="{ eventId: event.id }">
                <mat-list-item>
                  <h3 matListItemTitle>{{ event.name }}</h3>
                  <p matListItemLine>
                    <span>{{ event.description }}</span>
                  </p>
                </mat-list-item>
              </a>
            }
          </mat-nav-list>
        }
      </div>
    }
    <div class="load-more">
      @if (loading$ | async) {
        <mat-spinner [diameter]="24" />
      }
      @if (hasMore && (loading$ | async) === false) {
        <button mat-stroked-button (click)="loadMoreEvents()">
          Load more
        </button>
      }
    </div>
  </glxy-page-wrapper>
</glxy-page>
